import { OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loader',
    imports: [MatProgressSpinnerModule, OverlayModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {}
